(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-article-simple"]) return;
  try {
    
	var sideBarLeft = document.getElementById('sidebar_left');
	var sideBarRight = document.getElementById('sidebar_right');
	
	update = () => {
		if( window.innerWidth > 1199) {
			if (sideBarLeft != null) 
				sideBarLeft.classList.remove("offcanvas","offcanvas-start");
			if (sideBarRight != null) 
				sideBarRight.classList.remove("offcanvas","offcanvas-end");
		} else {
			if (sideBarLeft != null) 
				sideBarLeft.classList.add("offcanvas","offcanvas-start");
			if (sideBarRight != null) 
				sideBarRight.classList.add("offcanvas","offcanvas-end");
		}
	}
	if (sideBarLeft != null || sideBarRight != null) {
		window.update();
		window.addEventListener('resize', update);
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
	var sideBarLeft = document.getElementById('sidebar_left');
	var sideBarRight = document.getElementById('sidebar_right');
	
	update = () => {
		if( window.innerWidth > 992) {
			if (sideBarLeft != null) {
				sideBarLeft.classList.remove("offcanvas","offcanvas-start");
				sideBarLeft.classList.add("sticky-top");
			}
			if (sideBarRight != null) {
				sideBarRight.classList.remove("offcanvas","offcanvas-end");
				sideBarRight.classList.add("sticky-top");
			}
		} else {
			if (sideBarLeft != null) {
				sideBarLeft.classList.add("offcanvas","offcanvas-start");
				sideBarLeft.classList.remove("sticky-top");
			}
			if (sideBarRight != null) {
				sideBarRight.classList.add("offcanvas","offcanvas-end");
				sideBarRight.classList.remove("sticky-top");
			}
		}
	}
	if (sideBarLeft != null || sideBarRight != null) {
		window.update();
		window.addEventListener('resize', update);
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog-style1"]) return;
  try {
    
	var sideBarLeft = document.getElementById('sidebar_left');
	var sideBarRight = document.getElementById('sidebar_right');
	
	update = () => {
		if( window.innerWidth > 1199) {
			if (sideBarLeft != null) 
				sideBarLeft.classList.remove("offcanvas","offcanvas-start");
			if (sideBarRight != null) 
				sideBarRight.classList.remove("offcanvas","offcanvas-end");
		} else {
			if (sideBarLeft != null) 
				sideBarLeft.classList.add("offcanvas","offcanvas-start");
			if (sideBarRight != null) 
				sideBarRight.classList.add("offcanvas","offcanvas-end");
		}
	}
	if (sideBarLeft != null || sideBarRight != null) {
		window.update();
		window.addEventListener('resize', update);
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"]) return;
  try {
    
	var sideBarLeft = document.getElementById('sidebar_left');
	var sideBarRight = document.getElementById('sidebar_right');
	
	update = () => {
		if( window.innerWidth > 992) {
			if (sideBarLeft != null) {
				sideBarLeft.classList.remove("offcanvas","offcanvas-start");
				sideBarLeft.classList.add("sticky-top");
			}
			if (sideBarRight != null) {
				sideBarRight.classList.remove("offcanvas","offcanvas-end");
				sideBarRight.classList.add("sticky-top");
			}
		} else {
			if (sideBarLeft != null) {
				sideBarLeft.classList.add("offcanvas","offcanvas-start");
				sideBarLeft.classList.remove("sticky-top");
			}
			if (sideBarRight != null) {
				sideBarRight.classList.add("offcanvas","offcanvas-end");
				sideBarRight.classList.remove("sticky-top");
			}
		}
	}
	if (sideBarLeft != null || sideBarRight != null) {
		window.update();
		window.addEventListener('resize', update);
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
    class CartNote extends HTMLElement {
        constructor() {
        super();
        this.addEventListener('change', debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
        }, 300))
        }
    }
    customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
    class ProductRecommendations extends HTMLElement {
        constructor() {
            super();
            const handleIntersection = (entries, observer) => {
                if (!entries[0].isIntersecting) return;
                observer.unobserve(this);
                fetch(this.dataset.url)
                .then(response => response.text())
                .then(text => {
                    const html = document.createElement('div');
                    html.innerHTML = text;
                    const recommendations = html.querySelector('product-recommendations');
                    if (recommendations && recommendations.innerHTML.trim().length) {
                        this.innerHTML = recommendations.innerHTML;
                        vela.swatchProduct();

                        // Update wishlist button status
                        if ('wishlist' in vela && 'updateWishlist' in vela.wishlist) {
                            vela.wishlist.updateWishlist();
                        }

                        $('body').trigger('carousel:init', '.js-recommendations');
                        $('body').trigger('vela:countdown', '[data-countdown]');
                    }
                })
                .catch(e => {
                    console.error(e);
                });
            }
        
            new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
        }
    }
    customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-viewed"] && !Shopify.designMode) return;
  try {
    
    var vela = window.vela || {};
    vela.recentlyViewed = {
        name: 'vela_recently_viewed',
        symbol: '|',
        maximumItems: 10,
        exists: 365,
        products: []
    };

    // Load product handle from cookie
    var cookieRecentlyViewed = vela.getCookie(vela.recentlyViewed.name);
    if (cookieRecentlyViewed !== '') {
        var products = cookieRecentlyViewed.split(vela.recentlyViewed.symbol);
        products.forEach(function(item) {
            vela.recentlyViewed.products.push(item);
        });
    }

    // Add product handle to cookie.
    var pathname = window.location.pathname;
    if (vela && pathname.indexOf('/products/') !== -1) {
        var productHandle = pathname.match(/\/products\/([a-z0-9\-]+)/)[1];
        var currentIndex = vela.recentlyViewed.products.indexOf(productHandle);
        if (currentIndex === -1) {
            // Insert to first index
            vela.recentlyViewed.products.unshift(productHandle);
            // Only take vela.recentlyViewed.maximumItems items
            vela.recentlyViewed.products = vela.recentlyViewed.products.splice(0, vela.recentlyViewed.maximumItems);
        } else {
            // Remove current handle from array
            vela.recentlyViewed.products.splice(currentIndex, 1);
            // Insert to first index
            vela.recentlyViewed.products.unshift(productHandle);
        }

        // Set cookie
        if (vela.recentlyViewed.products.length > 0) {
            var productHandles = vela.recentlyViewed.products.join(vela.recentlyViewed.symbol);
            vela.setCookie(vela.recentlyViewed.name, productHandles, vela.recentlyViewed.exists);
        }
    }

    class ProductRecentlyViewed extends HTMLElement {
        constructor() {
            super();

            this.hiddenClass = 'd-none';
            this.container = this.querySelector('[data-products]');
            this.limit = parseInt(this.dataset.limit, 10);

            if (this.container) {
                this.layout = this.container.dataset.products;

                document.addEventListener("DOMContentLoaded", (event) => {
                    this.initPages();
                });
            }
        }

        initPages() {
            if (vela && vela.recentlyViewed && vela.recentlyViewed.products) {
                if (vela.recentlyViewed.products.length > 1) {
                    this.renderPages();
                } else {
                    this.classList.add(this.hiddenClass);
                }
            } else {
                this.classList.add(this.hiddenClass);
            }
        }

        async renderPages() {
            try {
                let promises = [];
                vela.recentlyViewed.products.forEach((handle, index) => {
                    if (handle && index !== 0 && index <= this.limit) {
                        const url = `${window.Shopify.routes.root}products/${handle}?view=product-card`;
                        promises.push(
                            fetch(url)
                                .then(response => response.text())
                                .then(text => {
                                    if (text && text !== '') {
                                        let productItem = document.createElement('div');
                                        const productItemClass = this.layout === 'grid' ? 'col' : 'slick-carousel__item';
                                        productItem.classList.add(productItemClass);
                                        productItem.innerHTML = text;

                                        return {
                                            element: productItem,
                                            handle: handle,
                                            index: index
                                        };
                                    }
                                })
                                .catch(e => {
                                    console.error(e);
                                })
                        );
                    }
                });

                let data = await Promise.all(promises);
                data.forEach(item => {
                    if ('element' in item) {
                        this.container.append(item.element);
                    }
                });
                this.afterRenderPage();
            } catch (e) {
                console.error(e);
            };
        }

        afterRenderPage() {
            this.classList.remove(this.hiddenClass);
            vela.swatchProduct();

            // Update wishlist button status
            if ('wishlist' in vela && 'updateWishlist' in vela.wishlist) {
                vela.wishlist.updateWishlist();
            }

            if (this.layout === 'carousel') {
                $('body').trigger('carousel:init', '.js-recently-viewed');
            }
            $('body').trigger('vela:countdown', '[data-countdown]');
        }
    }
    customElements.define('product-recently-viewed', ProductRecentlyViewed);

  } catch(e) { console.error(e); }
})();
})();
